export class SmartLocationAutocompleteConstant {
    public static LocationSelectionName:string= 'txtLocationSelection';
    public static LocationSelectionId:string= 'txtLocationSelectionId';
    public static Placeholder:string= 'Town, city or postcode';
    
}